import {IssuesLoadingSkeleton} from '@github-ui/issues-loading-skeleton'

import styles from './ParticipantsListLoading.module.css'

export function ParticipantsListLoading() {
  return (
    <div className={styles.participantsLoadingContainer}>
      <IssuesLoadingSkeleton height="md" width="60%" />
      <IssuesLoadingSkeleton height="md" width="80%" />
      <IssuesLoadingSkeleton height="md" width="40%" />
      <IssuesLoadingSkeleton height="md" width="60%" />
      <IssuesLoadingSkeleton height="md" width="70%" />
    </div>
  )
}
